import type { PomodoroState } from "../../features/pomodoro/hooks/use-pomodoro";
import type { TwentyState } from "../../features/twenty/hooks/use-twenty";
import type { StopwatchState } from "../../features/stopwatch/hooks/use-stopwatch";
import { PomodoroTimer } from "../../features/pomodoro/components/PomodoroTimer";
import { TwentyTimer } from "../../features/twenty/components/TwentyTimer";
import { StopwatchTimer } from "../../features/stopwatch/components/StopwatchTimer";
import { useModals } from "../../hooks/useModals";

interface DesktopTimerPanelProps {
  readonly showPomodoro: boolean;
  readonly showTwenty: boolean;
  readonly showStopwatch: boolean;
  readonly pomodoro: {
    readonly state: PomodoroState;
    readonly start: () => void;
    readonly pause: () => void;
    readonly reset: () => void;
    readonly skip: () => void;
  };
  readonly twenty: {
    readonly state: TwentyState;
    readonly start: () => void;
    readonly pause: () => void;
    readonly reset: () => void;
    readonly skip: () => void;
  };
  readonly stopwatch: {
    readonly state: StopwatchState;
    readonly start: () => void;
    readonly pause: () => void;
    readonly reset: () => void;
    readonly lap: () => void;
    readonly formatTime: (time: number) => string;
  };
}

export function DesktopTimerPanel({
  showPomodoro,
  showTwenty,
  showStopwatch,
  pomodoro,
  twenty,
  stopwatch,
}: DesktopTimerPanelProps) {
  const modals = useModals();

  if (!showPomodoro && !showTwenty && !showStopwatch) {
    return null;
  }

  return (
    <div className="w-full px-6 pt-3 pb-3 hidden xl:flex items-stretch gap-3 justify-center">
      {showPomodoro && (
        <div className="flex-1 flex flex-col max-w-sm">
          <PomodoroTimer
            state={pomodoro.state}
            onStart={pomodoro.start}
            onPause={pomodoro.pause}
            onReset={pomodoro.reset}
            onSkip={pomodoro.skip}
            onSettings={() => modals.setShowTimerSettings(true)}
          />
        </div>
      )}
      {showTwenty && (
        <div className="flex-1 flex flex-col max-w-sm">
          <TwentyTimer
            state={twenty.state}
            onStart={twenty.start}
            onPause={twenty.pause}
            onReset={twenty.reset}
            onSkip={twenty.skip}
            onSettings={() => modals.setShowTimerSettings(true)}
          />
        </div>
      )}
      {showStopwatch && (
        <div className="flex-1 flex flex-col max-w-sm">
          <StopwatchTimer
            state={stopwatch.state}
            onStart={stopwatch.start}
            onPause={stopwatch.pause}
            onReset={stopwatch.reset}
            onLap={stopwatch.lap}
            formatTime={stopwatch.formatTime}
            onSettings={() => modals.setShowTimerSettings(true)}
          />
        </div>
      )}
    </div>
  );
}
